import React from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import { UTLabel, WithLoading } from '@widergy/energy-ui';

import UTUserForm from 'app/components/UTUserForm';
import { PROCEDURE } from 'constants/userForms';
import { formPropType } from 'redux/userFormHandlers';
import { message } from 'utils/stringUtils';
import { UTILITIES } from 'constants/utilitiesMappers';
import { appConfig } from 'config/customization';

import styles from './styles.module.scss';
import siren from './assets/ic_siren.png';

function NewComplaintScene({ complaintForm, isPublic }) {
  return (
    <div className={styles.container}>
      <div className={`${styles.header} ${appConfig.mappers !== UTILITIES.eden && styles.border}`}>
        <div className={styles.titleSection}>
          <UTLabel large extrabold className={styles.title}>
            {message('Complaints:crimeComplaint')}
          </UTLabel>
          {appConfig.complaints.withSubtitles && (
            <UTLabel>{message('Complaints:crimeComplaintSubtitle')}</UTLabel>
          )}
        </div>
        {appConfig.complaints.withCrimeAlert && (
          <div className={styles.alert}>
            <img height={55} alt={message('Complaints:crimeComplaint')} src={siren} />
            <UTLabel white small className={styles.alertText}>
              {message('Complaints:crimeComplaintAlert')}
            </UTLabel>
          </div>
        )}
      </div>
      <div className={`${styles.field} ${appConfig.mappers === UTILITIES.edes && styles.edesField}`}>
        <UTUserForm
          formId={complaintForm && complaintForm.id}
          complaint
          formType={PROCEDURE}
          isPublic={isPublic}
        />
      </div>
    </div>
  );
}

NewComplaintScene.propTypes = {
  complaintForm: formPropType,
  isPublic: PropTypes.bool
};

export default WithLoading(props => props.loading)(Radium(NewComplaintScene));
